import ReactPlayer from 'react-player';
import { encodeFileNameInUrl } from '../../api/utils/util-func';
import Buttons from '../button/Buttons';
import { ProductContent } from '../../constants/types';
import { ProductContentType } from '../../enum';

interface ProductDetailContentsProps {
  contents: ProductContent[];
  productName: string;
  productSubType?: string;
  imageAltPrefix?: string;
}

/**
 * 신어드민의 상품관리에서 등록 및 수정한 "상세페이지 콘텐츠"를 렌더링합니다. (상품, 코스, 부스트업)
 * 영어교실(HOMESCHOOL), WMW, HFHJ 코스는 FE 컴포넌트로 렌더링하므로 여기 오지 않습니다.
 * 분기는 CourseDetails의 courseStaticDetailPage() 참고.
 * @param contents 상세페이지 콘텐츠 배열
 * @param productSubType 'LEARN_ON_PHONE'이면 전체 이미지를 jebsphone.com 링크로 감쌉니다.
 */
const ProductDetailContents = ({
  contents,
  productName,
  productSubType,
  imageAltPrefix = '',
}: ProductDetailContentsProps) => {
  return (
    <>
      {[...contents]
        .sort((a, b) => (a.order_idx ?? 0) - (b.order_idx ?? 0))
        .map((content: ProductContent) => {
          // 젭스폰 화상영어일때만
          if (productSubType === 'LEARN_ON_PHONE') {
            return (
              <a
                key={`${content.id}-${content.order_idx}`}
                href="https://www.jebsphone.com/"
                className="cursor-pointer"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={encodeFileNameInUrl(content.file.access_url)}
                  alt={`${productName} ${imageAltPrefix} 이미지`}
                  className="w-full"
                />
              </a>
            );
          }

          switch (content.type) {
            case ProductContentType.VIDEO:
              return (
                <div
                  key={`${content.id}-${content.order_idx}`}
                  className="aspect-video overflow-hidden"
                >
                  <ReactPlayer
                    url={content.video_url}
                    width="100%"
                    height="100%"
                    controls
                  />
                </div>
              );
            case ProductContentType.IMAGE:
              return (
                <img
                  key={`${content.id}-${content.order_idx}`}
                  src={encodeFileNameInUrl(content.file.access_url)}
                  alt={`${productName} ${imageAltPrefix} 이미지`}
                  className="w-full"
                />
              );
            case ProductContentType.URL:
              return (
                <div
                  key={`${content.id}-${content.order_idx}`}
                  className="mx-auto my-5 w-fit"
                >
                  <Buttons
                    type="filled"
                    color="purple5"
                    onClick={() => {
                      window.open(content.url_link, '_blank');
                    }}
                  >
                    {content.url_label}
                  </Buttons>
                </div>
              );
            default:
              return null;
          }
        })}
    </>
  );
};

export default ProductDetailContents;
